import { render, staticRenderFns } from "./Numerix.vue?vue&type=template&id=1571a422&scoped=true&"
import script from "./Numerix.vue?vue&type=script&lang=js&"
export * from "./Numerix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571a422",
  null
  
)

export default component.exports